/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Seo_Endpoint_Routing_MultiInputs */

const en_seo_endpoint_routing_multi = /** @type {(inputs: Seo_Endpoint_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI routes each request across ${i?.count} sources and falls back automatically when one fails.`)
};

const zh_hans1_seo_endpoint_routing_multi = /** @type {(inputs: Seo_Endpoint_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI 会在 ${i?.count} 个数据源之间路由每个请求，某个数据源失败时自动切换。`)
};

const pt_br2_seo_endpoint_routing_multi = /** @type {(inputs: Seo_Endpoint_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A AnyAPI distribui cada requisição entre ${i?.count} fontes, com failover automático quando uma falha.`)
};

const es_seo_endpoint_routing_multi = /** @type {(inputs: Seo_Endpoint_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI enruta cada solicitud entre ${i?.count} fuentes y recurre automáticamente a otra cuando una falla.`)
};

const fr_seo_endpoint_routing_multi = /** @type {(inputs: Seo_Endpoint_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI route chaque requête sur ${i?.count} sources et bascule automatiquement quand l’une échoue.`)
};

const de_seo_endpoint_routing_multi = /** @type {(inputs: Seo_Endpoint_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI routet jede Anfrage über ${i?.count} Quellen und weicht automatisch aus, wenn eine ausfällt.`)
};

const ru_seo_endpoint_routing_multi = /** @type {(inputs: Seo_Endpoint_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI направляет каждый запрос по источникам (их ${i?.count}) и автоматически переключается, если один из них отказывает.`)
};

const it_seo_endpoint_routing_multi = /** @type {(inputs: Seo_Endpoint_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI instrada ogni richiesta su ${i?.count} fonti e passa automaticamente a un'altra quando una fallisce.`)
};

/**
* | output |
* | --- |
* | "AnyAPI routes each request across {count} sources and falls back automatically when one fails." |
*
* @param {Seo_Endpoint_Routing_MultiInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_routing_multi = /** @type {((inputs: Seo_Endpoint_Routing_MultiInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Routing_MultiInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_routing_multi(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_routing_multi(inputs)
	if (locale === "es") return es_seo_endpoint_routing_multi(inputs)
	if (locale === "fr") return fr_seo_endpoint_routing_multi(inputs)
	if (locale === "de") return de_seo_endpoint_routing_multi(inputs)
	if (locale === "ru") return ru_seo_endpoint_routing_multi(inputs)
	if (locale === "it") return it_seo_endpoint_routing_multi(inputs)
	return en_seo_endpoint_routing_multi(inputs)
});